import { z } from 'zod';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';
import { currentLocale } from '~/utils/i18n';

import { UNIT_TYPE, UNITS_LANGUAGE } from './constants';

export const zodUnitsSearchParamsSchema = z
  .object({
    language: z
      .preprocess(
        (value) =>
          typeof value === 'string' ? value.toUpperCase() : undefined,
        z.enum(UNITS_LANGUAGE),
      )
      .optional()
      .prefault(() => currentLocale().toUpperCase()),
    unitType: z.array(z.enum(UNIT_TYPE)).optional(),
  })
  .transform((value) =>
    withoutObjectKeysWhereValueIs(value, [null, undefined, '']),
  );
